import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.27635 3.41915C6.01291 3.28385 6.9143 3.25797 7.99583 3.25195L8.00418 4.75193C6.91068 4.75802 6.13559 4.78641 5.54735 4.89447C4.98054 4.99858 4.65246 5.16576 4.40901 5.40921C4.13225 5.68598 3.9518 6.07455 3.85315 6.80832C3.75159 7.56367 3.75 8.56479 3.75 10.0002V16.0002C3.75 17.4356 3.75159 18.4367 3.85315 19.1921C3.9518 19.9259 4.13225 20.3144 4.40901 20.5912C4.68577 20.868 5.07435 21.0484 5.80812 21.1471C6.56347 21.2486 7.56458 21.2502 9 21.2502H15C16.4354 21.2502 17.4365 21.2486 18.1919 21.1471C18.9257 21.0484 19.3142 20.868 19.591 20.5912C19.8678 20.3144 20.0482 19.9259 20.1469 19.1921C20.2484 18.4367 20.25 17.4356 20.25 16.0002V10.0002C20.25 8.56479 20.2484 7.56367 20.1469 6.80832C20.0482 6.07455 19.8678 5.68598 19.591 5.40921C19.3475 5.16576 19.0195 4.99858 18.4527 4.89447C17.8644 4.78641 17.0893 4.75802 15.9958 4.75193L16.0042 3.25195C17.0857 3.25797 17.9871 3.28385 18.7236 3.41915C19.4816 3.55838 20.1267 3.82362 20.6517 4.34855C21.2536 4.95047 21.5125 5.70834 21.6335 6.60845C21.75 7.47542 21.75 8.57774 21.75 9.94533V16.0551C21.75 17.4227 21.75 18.525 21.6335 19.392C21.5125 20.2921 21.2536 21.0499 20.6517 21.6519C20.0497 22.2538 19.2919 22.5127 18.3918 22.6337C17.5248 22.7502 16.4225 22.7502 15.0549 22.7502H8.94513C7.57754 22.7502 6.47522 22.7502 5.60825 22.6337C4.70814 22.5127 3.95027 22.2538 3.34835 21.6519C2.74643 21.0499 2.48754 20.2921 2.36652 19.392C2.24996 18.525 2.24998 17.4227 2.25 16.0551V9.94533C2.24998 8.57774 2.24996 7.47542 2.36652 6.60845C2.48754 5.70834 2.74643 4.95047 3.34835 4.34855C3.87328 3.82362 4.51836 3.55838 5.27635 3.41915Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 14C9.75 13.5858 10.0858 13.25 10.5 13.25L17 13.25C17.4142 13.25 17.75 13.5858 17.75 14C17.75 14.4142 17.4142 14.75 17 14.75L10.5 14.75C10.0858 14.75 9.75 14.4142 9.75 14Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H7.5C7.91421 13.25 8.25 13.5858 8.25 14C8.25 14.4142 7.91421 14.75 7.5 14.75H7C6.58579 14.75 6.25 14.4142 6.25 14Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 10.5C6.25 10.0858 6.58579 9.75 7 9.75H7.5C7.91421 9.75 8.25 10.0858 8.25 10.5C8.25 10.9142 7.91421 11.25 7.5 11.25H7C6.58579 11.25 6.25 10.9142 6.25 10.5Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 17.5C6.25 17.0858 6.58579 16.75 7 16.75H7.5C7.91421 16.75 8.25 17.0858 8.25 17.5C8.25 17.9142 7.91421 18.25 7.5 18.25H7C6.58579 18.25 6.25 17.9142 6.25 17.5Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 10.5C9.75 10.0858 10.0858 9.75 10.5 9.75H17C17.4142 9.75 17.75 10.0858 17.75 10.5C17.75 10.9142 17.4142 11.25 17 11.25H10.5C10.0858 11.25 9.75 10.9142 9.75 10.5Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 17.5C9.75 17.0858 10.0858 16.75 10.5 16.75H17C17.4142 16.75 17.75 17.0858 17.75 17.5C17.75 17.9142 17.4142 18.25 17 18.25H10.5C10.0858 18.25 9.75 17.9142 9.75 17.5Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 3.5C7.25 2.25736 8.25736 1.25 9.5 1.25H14.5C15.7426 1.25 16.75 2.25736 16.75 3.5V4.5C16.75 5.74264 15.7426 6.75 14.5 6.75H9.5C8.25736 6.75 7.25 5.74264 7.25 4.5V3.5ZM9.5 2.75C9.08579 2.75 8.75 3.08579 8.75 3.5V4.5C8.75 4.91421 9.08579 5.25 9.5 5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5V3.5C15.25 3.08579 14.9142 2.75 14.5 2.75H9.5Z"
        fill={colorValue}
      />
    </svg>
  );
};
